import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { SessionIdResolverService } from './session-id-resolver.service';

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled',
    scrollOffset: [0, 64],
    //relativeLinkResolution: 'legacy'
};


const routes: Routes = [

  {
    path: 'tool',
        canActivate: [MsalGuard],
        resolve: { sessionId: SessionIdResolverService },
    loadChildren: () => import(`./tools/tools.module`)
      .then(m => m.ToolsModule),
  },
  {
    path: 'execution',
      canActivate: [MsalGuard],
      resolve: { sessionId: SessionIdResolverService },
    loadChildren: () => import(`./tools/tools.module`)
      .then(m => m.ToolsModule),
  },
  {
    path: '',
    resolve: {sessionId: SessionIdResolverService},
    canActivate: [MsalGuard],
    loadChildren: () => import(`./ui/ui-components.module`)
      .then(m => m.UiComponentsModule),
  },
    { path: '**',
    redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule]
})

export class AppRoutingModule { }
